import React from 'react';
import adaptTransactionsToSections from 'shared/components/TransactionSectionList/AdaptTransactionsToSectionedContentScreenArray';
import { TransactionListItemProps } from 'shared/components/vxl/TransactionListItem/TransactionListItem';
import SectionedContentScreen, {
  SectionedContentScreenModel,
  SectionedContentScreenProps,
} from 'shared/containers/vxl/SectionedContentScreen/SectionedContentScreen';
import { VXLNode } from 'shared/renderer/types';

export interface TransactionGroup {
  title: string;
  transactions: TransactionListItemProps[];
}

export type Transactions = TransactionListItemProps[] | TransactionGroup[];

interface TransactionsSectionListProps
  extends Omit<SectionedContentScreenProps, 'model'> {
  header?: VXLNode;
  footer?: VXLNode;
  transactions: Transactions;
  scrollEnabled?: boolean;
}

const TransactionsSectionList = ({
  transactions,
  header,
  footer,
  scrollEnabled,
}: TransactionsSectionListProps) => {
  const transactionSectionsModel: SectionedContentScreenModel = {
    header: header,
    footer: footer,
    sections: adaptTransactionsToSections(transactions) || [],
  };

  return (
    <SectionedContentScreen
      model={transactionSectionsModel}
      scrollEnabled={scrollEnabled}
    />
  );
};

export default TransactionsSectionList;
